import { createBrowserHistory } from "history";

/**
 * Export history object
 * Configure history here if necessary
 */
export default createBrowserHistory();
